var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeTotalLookDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 500",
    style: {
      enableBackground: "new 0 0 520 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.facade-total-st0{fill:none;stroke:#FFFFFF;stroke-width:1.5;}\n\t.facade-total-st1{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.facade-total-st2{fill:#FFFFFF;}\n\t.facade-total-st3{mask:url(#mask0_681_6029_1_);}\n\t.facade-total-st4{fill:none;stroke:#F7F7F7;stroke-width:1.5;}\n\t.facade-total-st5{fill:#FFFFFF;fill-opacity:0.2;}\n\t.facade-total-st6{fill:none;stroke:#FFFFFF;stroke-linecap:square;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M375.5,285.8l-25.3,161.9h-60.3l15-161.9H375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M358.7,421l19.5-135.3h3.5L399,447.6h-32L358.7,421z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 265.6,
    y: 268.6,
    width: 144.1,
    height: 220.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 265.6,
    y: 268.6,
    width: 144.1,
    height: 220.6,
    id: "mask0_681_6029_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st1",
    d: "M304.1,285L289,448.4h61.8L376.4,285H304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M382.4,285h-4.9l-19.6,136.1l8.5,27.3h33.4L382.4,285z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "facade-total-st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M283.6,277.8c9.6,11.3,28.7,39.3,28.7,61.1c0,21.8-30.8-4.8-46.3-20.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M344.2,488.8c-21.7-43.4-39.8-99.8-33.2-121.4c6.5-21.7,12.3,69.4-26.7,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M380.5,480.2c0-23.1,1.4-66.9,7.2-57.1c7.2,12.3,10.8,54.2,21.7,57.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "facade-total-st4",
    cx: 303,
    cy: 428.8,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M374,461.5c-27.9-9.5,48.7-134.6-16-41 M374,279.7c-26.7,0-30,51-38.6,66.6c-10.8,19.5-24-49.1-9.5-77.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st0",
    d: "M331.8,456.8c-8.9-54.1,33.3-76.7,14.3-94.5c-21.1-19.8-14.3,52.9,55.2-36.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "facade-total-st5",
    cx: 262.5,
    cy: 245.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "facade-total-st0",
    cx: 262.5,
    cy: 245.5,
    r: 24.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st6",
    d: "M262.5,237.2v16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st6",
    d: "M254.2,245.5h16.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M160.5,116.6c-18-22.5-19.8-42.4-16.7-55.8l-0.5-0.8h-13.1c-3.5,12.1-3.9,31.4,6.6,57.2 c12.9,31.7,12.1,68.1,6.1,92.8h48.2C192.3,162.5,174.6,134.2,160.5,116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M113,70.8L99.3,84.9c-2.2,10-4,21.3-4.9,33.4l11,9l5.3-3.3C108.6,101.6,110.1,83.9,113,70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M145,62.6c-2.6,12.9-0.3,31.7,16.7,53.1c27,33.9,31.8,68.1,31,94.4h29.1l-8.7-42.2L145,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M135.5,117.8C124.9,92,125.3,72.5,128.7,60h-5.2l-8.5,8.8c-3.1,13-5,31-2.9,54.3l16.8-10.4l-13.3,97.5h25.9 C147.5,185.6,148.4,149.4,135.5,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M79,105.7l14,11.4c0.9-10.8,2.4-21,4.4-30.2L79,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M195.7,97c-8.4-1.8-14.6-6.1-18.6-12.7c-1.1-1.9-2-3.9-2.7-6l-8.1,10.5l44.2,68.6l-7.6-44.8l23.6,14.6 l20.2-16.5c-9.3-6.2-21.3-8.3-34.8-10.6C206.7,99.2,201.3,98.2,195.7,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M196.1,95.6c5.6,1.2,10.9,2.1,16.1,3c14,2.4,26.3,4.6,35.8,11.1l4.9-4L208.4,60h-19.8l-4.4,5.7 c1.2,1.8,2.5,3.6,4.1,5.2c8.6,8.7,22,12.3,39.8,11l0.1,1.5c-2.5,0.2-4.9,0.3-7.2,0.3c-14.7,0-26.1-3.9-33.8-11.7 c-1.6-1.6-2.9-3.2-4.1-5l-7.6,9.9c0.7,2.4,1.6,4.6,2.9,6.7C182.2,89.8,188.1,93.8,196.1,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-total-st2",
    d: "M266.2,70.7l9-9.3c2.2-2.3,2.5-6,0.4-8.4c-0.5-0.6-1.2-1.1-1.9-1.4c-0.7-0.3-1.5-0.5-2.3-0.5 c-0.8,0-1.6,0.1-2.3,0.4c-0.7,0.3-1.4,0.8-1.9,1.3l-1.7,1.7l-1.5-1.5c-2.2-2.3-5.8-2.6-8.2-0.5c-0.6,0.5-1.1,1.2-1.4,1.9 c-0.3,0.7-0.5,1.5-0.5,2.3c0,0.8,0.1,1.6,0.4,2.4c0.3,0.8,0.7,1.4,1.3,2l9.2,9.5c0.2,0.2,0.4,0.3,0.6,0.3 C265.8,71,266,70.9,266.2,70.7L266.2,70.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeTotalLookDesktop);
export default __webpack_public_path__ + "static/media/facade-total-look-desktop.6337445a.svg";
export { ForwardRef as ReactComponent };